var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagebar"},[_c('el-pagination',{attrs:{"page-sizes":[10, 20, 50, 100, 300],"current-page":_vm.page.page + (_vm.zeroBase ? 1 : 0),"page-size":_vm.page.limit,"total":_vm.page.total,"layout":"total, sizes, prev, pager, next, jumper"},on:{"current-change":_vm.handleCurrentChange,"size-change":_vm.handleSizeChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }